<form [formGroup]="rejectForm">

  <mat-dialog-content>
    <p>
      {{message}}
    </p>
  </mat-dialog-content>

  <mat-radio-group formControlName="rejectValue" fxLayoutAlign="space-between stretch" fxLayout="column">
    <mat-radio-button [checked]="reject == rejectValue" *ngFor="let reject of rejectList" class="radio-button" value="{{reject}}">{{reject}}</mat-radio-button>
  </mat-radio-group>

  <mat-dialog-actions align="center">
    <button mat-raised-button (click)="onConfirmClick()" color="primary" tabindex="1" [disabled]="rejectForm.invalid">{{confirmButtonText}}</button>
    <button mat-raised-button mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
  </mat-dialog-actions>

</form>
